import React, { useEffect } from "react";
import { useState } from "react"
import { Button, Stack, Typography, Divider, IconButton, TextField } from "@mui/material"
import { Avatar, Box } from "@mui/material"
import { Popover } from "@mui/material"
import { setAppTheme } from "../Settings/appTheme";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { useMCContext } from "../contexts/useMCStates";


interface AccountHeaderBlockProps {
    props: any;
}


export const AccountHeaderBlock = ({props}: AccountHeaderBlockProps) => {

    const auth = useAuth();
    const navigate = useNavigate();

    const { paddingWidth, headerName, bgOn, bgOff } = props;
    const { factor, setFactor, setTheme } = useMCContext();

    const [openAccountMenu, setOpenAccountMenu] = useState(false);
    const [zoom, setZoom] = useState(factor*100);

    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN ?? '';
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID ?? '';

    const handleSetUpPasskey = () => {
        window.location.href = `${cognitoDomain}/passkeys/add?client_id=${clientId}&redirect_uri=${encodeURIComponent(window.location.origin)}`;
    };

    const signOutRedirect = () => {
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(window.location.origin)}`;
    };

  useEffect(() => {
    //console.log('Acct Factor', factor);
    //console.log('Acct Zoom', zoom);
    setZoom(factor*100);
  }, [factor]);

  //console.log(auth);

    return (
        <Box>
            <Avatar id='account-header-avatar' 
                sx={{ 
                    backgroundColor: openAccountMenu ? (bgOn ? bgOn : 'secondary.main') : (bgOff ? bgOff : 'lightgray'), 
                    width: 30*factor, 
                    height: 30*factor,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                onClick={() => setOpenAccountMenu(true)}
            >
                {auth?.user &&
                <Typography variant='subtitle1' sx={{ fontWeight: 500, color: 'primary.main', fontSize: '0.72em' }}>
                    {auth.user?.profile.given_name?.[0]}{auth.user?.profile.family_name?.[0]}
                </Typography>
                }

            </Avatar>
            <Popover
                open={openAccountMenu}

                onClose={() => setOpenAccountMenu(false)}
                anchorEl={document.querySelector(`#${headerName}`)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                sx={{ marginLeft: `${paddingWidth-5}px` }}
            >
                <Box
                    sx={{
                        padding: 1,
                        minHeight: '100px',
                        minWidth: '250px'
                    }}
                >
                    <Typography variant='subtitle1' sx={{ fontWeight: 500, width: '100%', textAlign: 'center' }}>Settings</Typography>
                    <Divider />
                    {auth?.user && (
                        <><Stack direction='column' gap={'3px'} padding={'5px 15px'}>
                            <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>
                                {auth.user?.profile.given_name} {auth.user?.profile.family_name}
                            </Typography>
                            <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>
                                {auth.user?.profile.email}
                            </Typography>
                        </Stack>
                        <Divider /></>
                    )}
                    <Stack direction={'column'} spacing={1} padding={1}>
                        
                        <IconButton
                            sx={{ backgroundColor: 'transparent', borderRadius: 2, height: 25 }} 
                            onClick={() => {
                                navigate('/myAccount');
                            }}
                        >
                            <Typography variant='caption' sx={{ width: '100%', textAlign: 'left', color: 'black' }}>My Account</Typography>
                        </IconButton>
                        {/* <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>Subscription: Personal - Free</Typography>
                        <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>Restore Purchases</Typography>
                        <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>Data Settings</Typography>
                        <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>Terms of Service</Typography>
                         */}<Stack direction="row" spacing={1} alignItems="center" padding={1}>
                            <Typography variant='caption' sx={{ width: '50%', textAlign: 'left' }}>Page Zoom</Typography>
                            <Stack direction="row" spacing={1} alignItems="center">
                            <IconButton 
                                sx={{ backgroundColor: 'transparent', borderRadius: 1, height: 25 }} 
                                    onClick={() => {
//console.log('Zoom changing to:', zoom-5);
                                        setZoom((zoom-5));
                                        setFactor((zoom-5)/100);
                                        setTheme(setAppTheme((zoom-5)/100))
                                    }}>
                                    <Typography variant="body1">-</Typography>
                                </IconButton>
                                <TextField 
                                    type="number" 
                                    variant="outlined" 
                                    size="small" 
                                    inputProps={{ 
                                        style: { 
                                            textAlign: 'center',
                                            padding: '4px',
                                            fontSize: 14,
                                            width: 40
                                        },
                                        onFocus: (e) => e.target.select() // Select the whole value on focus
                                    }} 
                                    value={zoom} // Default zoom level
                                    onChange={(e) => {
                                        setZoom(Number(e.target.value.replace(/^0+/, '')));
                                    }}
                                    onBlur={(e) => {
                                        setZoom((Number(e.target.value)));
                                        setFactor((Number(e.target.value)/100));
                                        setTheme(setAppTheme(Number(e.target.value)/100))
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            (e.target as HTMLInputElement).blur();
                                        }
                                    }}
                                />
                                <IconButton 
                                    sx={{ backgroundColor: 'transparent', borderRadius: 1, height: 25 }} 
                                    onClick={(e) => {
                                        setZoom((zoom+5));
                                        setFactor((zoom+5)/100);
                                        setTheme(setAppTheme((zoom+5)/100))
                                    }}>
                                    <Typography variant="body1">+</Typography>
                                </IconButton>
                            </Stack>
                        </Stack>
                        <Divider />
                        <Box sx={{ width: '100%', justifyContent: 'flex-start' }}>
                            <Button
                                variant='text'
                                sx={{ color: 'primary.main', padding: 0 }}
                                onClick={handleSetUpPasskey}
                            >
                                <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>
                                    Set up passkey
                                </Typography>
                            </Button>
                        </Box>
                        <Box sx={{ width: '100%', minHeight: 20}} />
                        <Divider />
                        <Box sx={{ width: '100%', justifyContent: 'flex-start'}}>
                            {auth?.user ?
                            <Button variant='text' sx={{ color: 'primary.main', padding: 0 }}
                                onClick={async () => {
                                    auth.signoutSilent();
                                    signOutRedirect();
                                }}
                            >
                                <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>Sign Out</Typography>
                            </Button>
                            :
                            <Button variant='text' sx={{ color: 'primary.main', padding: 0 }}
                                onClick={async () => {
                                    localStorage.setItem('redirectURL', window.location.pathname);
                                    auth.signinRedirect();
                                }}
                            >
                                <Typography variant='caption' sx={{ width: '100%', textAlign: 'left' }}>Sign In</Typography>

                            </Button>
                            }
                        </Box>


                    </Stack>
                    
                </Box>
                
            </Popover>
        </Box>
    )
}
